import React, {Component} from 'react';
import {
    View,
    TextInput,
    BackHandler,
    Alert,
    Image,
    TouchableOpacity,
    Platform,
    KeyboardAvoidingView,
    ImageBackground,
    NativeModules,
    FlatList,
    Text, I18nManager

} from "react-native"

import {Swiper} from "./src/Swiper";


export default class HMSwiper extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // value: 'احمد'
        }
    }

    componentWillReceiveProps(props) {


    }

    componentDidMount() {
        // BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);
    }

    componentWillUnmount() {
        //BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);
    }

    render() {
        let {item, list, renderItem, notLoop, notClick, notAutoPlay, key} = this.props;
        //  let checkLogin = (store.getState().reducerSplashSatiaScreen.TypeLogin == 2)
        return (

            <Swiper
                // {...this.props}
                // key={key?key:list.length}
                key={(list && list[0] ? list[0].title : null) || (item ? item.id : "0") + "_" + list.length}
                loop={!notLoop}
                timeout={notAutoPlay ? null : (!I18nManager.isRTL ? -4.5 : 4.5)}
                from={!I18nManager.isRTL && list ? list.length - 1 : 0}
                minDistanceForAction={0.1}
                controlsProps={{
                    dotsTouchable: true,
                    prevPos: 'left',
                    nextPos: 'right',
                    nextTitle: '>',
                    nextTitleStyle: {color: 'red', fontSize: 24, fontWeight: '500'},
                    PrevComponent: ({onPress}) => (
                        list && list.length > 1 ?
                            <TouchableOpacity onPress={onPress}>
                                <Text style={{color: 'white', fontSize: 24, fontWeight: '500'}}>
                                    {notClick ? "" : (!I18nManager.isRTL ? '<' : '>')}
                                </Text>
                            </TouchableOpacity>
                            : null
                    ),
                    NextComponent: ({onPress}) => (
                        list && list.length > 1 ?
                            <TouchableOpacity onPress={onPress}>
                                <Text style={{color: 'white', fontSize: 24, fontWeight: '500'}}>
                                    {notClick ? "" : (I18nManager.isRTL ? '<' : '>')}
                                </Text>
                            </TouchableOpacity>
                            :
                            null
                    ),
                }}
            >
                {
                    list ?
                        renderItem()
                        :
                        null
                }
                {/*    <View style={{flex:1,alignItems:"center",justifyContent:"center",backgroundColor:"rgba(20,20,200,0.3)"}}>
                                        <Text>Slide 1</Text>
                                    </View>
                                    <View style={{flex:1,alignItems:"center",justifyContent:"center",backgroundColor:"rgba(20,200,20,0.3)"}}>
                                        <Text>Slide 2</Text>
                                    </View>
                                    <View style={{flex:1,alignItems:"center",justifyContent:"center",backgroundColor:"rgba(200,20,20,0.3)"}}>
                                        <Text>Slide 3</Text>
                                    </View>*/}
            </Swiper>

        );
    }


}
